import React from "react";
import { Icon, FlyoutFullScreen, Modal } from "@accessdev/arc-ui-react";
import Media from "react-media";
import { mediaBreakpoints } from "@accessdev/arc-ui-react/utils/js";

import "./OfferTerms.scss";
import { Trans } from "@lingui/react/macro";
import { t, msg } from "@lingui/core/macro";
import { useLingui } from "@lingui/react";

export const OfferTermBlock = ({ offer }) => {
  const { _ } = useLingui();
  const { terms, uses_per_period } = offer;
  return (
    <div className="offer-terms__display">
      <h1 className="t-title-large">
        <Trans>Offer Terms</Trans>
      </h1>
      <span className="offer-terms__display-limited t-label-small">
        {uses_per_period === _(msg`unlimited`) ? "" : _(msg`Limit ${uses_per_period}`)}
      </span>
      {!!terms && <span className="t-body-small" dangerouslySetInnerHTML={{ __html: terms }} />}
    </div>
  );
};

class OfferTerms extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isTermsOpen: false,
    };
    this.triggerRef = React.createRef(null);
  }
  openTermsModal = () => {
    this.setState({
      isTermsOpen: true,
    });
  };

  closeTermsModal = () => {
    this.setState({ isTermsOpen: false });
    this.triggerRef.current.focus();
  };
  render() {
    const { offer } = this.props;
    const { isTermsOpen } = this.state;
    return (
      <>
        <button
          ref={this.triggerRef}
          className="offer-terms__link t-label-small"
          onClick={this.openTermsModal}
          title={t`View offer terms`}
          tabIndex={this.props.tabIndex}
          aria-haspopup="true"
        >
          <Trans>offer terms</Trans>
        </button>
        {isTermsOpen && (
          <Media query={mediaBreakpoints.forPhoneOnly}>
            {(isPhone) =>
              isPhone ? (
                <FlyoutFullScreen
                  defaultPadding={false}
                  isOpen={isTermsOpen}
                  onClose={this.closeTermsModal}
                  variant="terms__flyout"
                >
                  <Icon
                    icon="close"
                    className="offer-terms__close"
                    onClick={this.closeTermsModal}
                    type="button"
                    title={t`Close terms`}
                  />
                  <OfferTermBlock offer={offer} />
                </FlyoutFullScreen>
              ) : (
                <Modal className={"terms"} onClose={this.closeTermsModal}>
                  <OfferTermBlock offer={offer} />
                </Modal>
              )
            }
          </Media>
        )}
      </>
    );
  }
}
export default OfferTerms;
